<template>
  <div class="manager-container" v-loading="dataLoading">
    <div class="flex-between-row">
      <h1 class="div-main-view-title">System Log</h1>
    </div>
    <el-row class="shadow-border-bottom" type="flex">
      <div class="button-block">
        <div class="query-item">
          <el-date-picker
            clearable
            v-model="dateRange"
            type="daterange"
            format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="getLogs">
          </el-date-picker>
        </div>
        <div class="query-item">
          <el-input  placeholder="Search By User Name" v-model="userNameSearch" clearable
            @keypress.enter.native="getLogs()">
            <!-- <el-button type="primary" slot="append" icon="el-icon-search" @click="getJobTableData()"></el-button> -->
          </el-input>
        </div>
        <div class="query-item">
          <el-input  placeholder="Search By IP" v-model="ipSearch" clearable
            @keypress.enter.native="getLogs()">
            <!-- <el-button type="primary" slot="append" icon="el-icon-search" @click="getJobTableData()"></el-button> -->
          </el-input>
        </div>
        <div class="query-item">
          <el-select v-model="clientTypeSearch" placeholder="Select Client Type" clearable
            @change="getLogs">
            <el-option
              v-for="item in clientTypeSelect"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
    </el-row>
    <div class="table-block " :style="{ height: 'calc(100% - 85px)' }">
      <el-table
        :data="tableData"
        :empty-text="'No data found'"
        border
        height="100%"
        :header-cell-style="HEADER_CELL_STYLE" 
        :cell-style="CELL_STYLE"
      >
        <el-table-column prop="ip" label="Client IP" width="100"></el-table-column>
        <el-table-column prop="userAgent" label="User Agent" width="200"></el-table-column>
        <el-table-column prop="userName" label="User Name" width="150"></el-table-column>
        <el-table-column prop="roleName" label="Role Name" width="150"></el-table-column>
        <el-table-column prop="clientType" label="Client Type" width="150">
          <template v-slot="scope">
            <span>
              {{ scope.row.clientType === "1" ? "Web" : 
                scope.row.clientType === "2" ? "Tablet" : "" }} 
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="Log Title" width="200"></el-table-column>

        <!-- <el-table-column prop="method" label="Request Method" width="120"></el-table-column> -->
        <el-table-column prop="requestUri" label="URI" width="200"></el-table-column>
        <el-table-column prop="params" label="Payload" width="300"></el-table-column>
        <!-- <el-table-column prop="remoteAddr" label="Request Address" width="200"></el-table-column> -->
        <el-table-column prop="resultParams" label="Response" width="300">
          <template v-slot="scope">
            <template v-if="scope.row.resultParams">
              <el-collapse class="no-border">
                <el-collapse-item title="Response Params">
                  <div style="display: flex; flex-direction: column; gap: 5px">
                    <pre>{{ formatJson(scope.row.resultParams) }}</pre>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-else>
              <div> </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column prop="operateDate" label="Operation Time" width="150"></el-table-column>
        <el-table-column prop="startTime" label="Start Time" width="150"></el-table-column>
        <el-table-column prop="endTime" label="End Time" width="150"></el-table-column>

        <!-- <el-table-column prop="tenantId" label="Tenant ID" width="180"></el-table-column> -->
        <!-- <el-table-column prop="creator" label="Creator" width="150"></el-table-column> -->
        <!-- <el-table-column prop="deleted" label="Deleted" width="100"></el-table-column> -->
        <!-- <el-table-column prop="id" label="ID" width="150"></el-table-column> -->
        <!-- <el-table-column prop="createTime" label="Create Time" width="150"></el-table-column> -->
        <!-- <el-table-column prop="updateTime" label="Update Time" width="150"></el-table-column> -->
        <!-- <el-table-column prop="exception" label="Exception" width="100"></el-table-column> -->
        <el-table-column prop="logId" label="Log ID" width="150"></el-table-column>


        <!-- <el-table-column prop="timeout" label="Timeout" width="150"></el-table-column> -->
        <!-- <el-table-column prop="type" label="Log Type" width="150"></el-table-column> -->
        <!-- <el-table-column prop="userId" label="User ID" width="150"></el-table-column> -->
        <!-- <el-table-column prop="deviceId" label="Device ID" width="200"></el-table-column> -->
      </el-table>
    </div>
    <div style="display: flex; justify-content: flex-end;">
      <el-pagination
        style="position: absolute;"
        background @size-change="handlePageSizeChange" @current-change="handlePageNumberChange"
        :page-size.sync="pagination.pageSize" :page-sizes="[5, 10, 20, 50, 100]"
        :current-page="pagination.pageNumber" layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { sortByAlphabetical, serverSGDateTimeFormat  } from "@/utils";
import { HEADER_CELL_STYLE, CELL_STYLE } from '@/constants.js'

export default {
  name: 'SystemLog',
  data () {
    return {
      HEADER_CELL_STYLE,
      CELL_STYLE,
      dataLoading: false,
      pagination: {
        pageSize: 20,
        pageNumber: 1,
        total: 0,
      },
      total: 0,
      tableData: [],
      dateRange:[],
      clientTypeSearch:"",
      userNameSearch:"",
      ipSearch:"",
      clientTypeSearch:"",
      clientTypeSelect:[
        { value: "1", label: "Web"},
        { value: "2", label: "Tablet"},
      ]
    }
  },
  computed: {
    ...mapState(["currentCompany", "permissions"]),
  },
  mounted() {
    this.getLogs()
  },
  methods: {
    sortByAlphabetical,
    serverSGDateTimeFormat,
    async getLogs(){
      this.dataLoading = true;
      try{
        const { pageSize, pageNumber } = this.pagination;
        const [startDate, endDate] = this.dateRange || [];
        // const res = await this.$request.get({
        //   url: `${this.$apis.getSystemLog}?pageSize=${this.pagination.pageSize}&pageNumber=${this.pagination.pageNumber}`
        // })
        const res = await this.$request.get({
          url: this.$apis.getSystemLog,
          params: {
            pageSize,
            pageNumber,
            startDate,
            endDate,
            clientType: this.clientTypeSearch,
            userName: this.userNameSearch,
            ip: this.ipSearch,
          }
        });
        if( res.code == 1000 ) {
          this.tableData = res.data?.records ?? []
          this.pagination.total = res.data?.total ?? 0
        }
      }catch (e) {
        this.$message.error('Error retrieving system log')
      } finally {
        this.dataLoading = false
      }
    },
    formatJson(jsonString) {
      try {
        return JSON.stringify(JSON.parse(jsonString), null, 2);
      } catch (e) {
        return jsonString;
      }
    },
    handlePageSizeChange(size) {
      this.pagination.pageSize = size
      this.getLogs()
    },
    handlePageNumberChange(number) {
      this.pagination.pageNumber = number
      this.getLogs()
    },
  }
}
</script>

<style lang="scss" scoped>
.manager-container {
  height: 100%;
  width: 100%;

  /deep/ .el-loading-spinner i {
    font-size: 30px;
  }

  .handler-bar {
    /deep/ .el-tabs__nav-wrap::after {
      background-color: transparent;
    }

    /deep/ .el-input__inner {
      border-color: #eaecef;
    }

    /deep/ .el-tabs__nav-next,
    /deep/ .el-tabs__nav-prev {
      font-size: 12px;
      // color: #0f376a;
    }
  }

  .button-block {
    @include flex-center-row;
    justify-content: flex-end;
    box-sizing: border-box;
    width: 100%;

    .query-item {
      display: inline-flex;
      align-items: center;
      margin: 10px 0 0px 15px;
    }

    .button-item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
.no-border {
  border: none;
}
.no-border .el-collapse-item__wrap {
  border: none !important;
}
.no-border .el-collapse-item__header {
  border-bottom: none !important;
}
pre {
  font-family: inherit;
  font-size: 12px;
  // white-space: pre-wrap;
  // word-break: break-word;
  margin: 0;
}
</style>